import EcommerceProductViewWrapper from './EcommerceProductViewWrapper';

export default EcommerceProductViewWrapper;
